import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Headline } from '@lichtblick/photon/atoms/headline/headline';
import { Text } from '@lichtblick/photon/atoms/text/text';
import { InfoM } from '@lichtblick/photon/icons/symbols/info-m';
import themes from '@lichtblick/photon/theme/theme.module.css';
import utilityStyles from '@lichtblick/photon/theme/utilities.module.scss';
import classNames from 'classnames';
import { AButton } from '../AButton';
import styles from './info-teaser.module.css';
/**
 * Maps legacy Storyblok theme values to the new theme system.
 * TODO: Remove this mapping after content migration is complete.
 */ const themeColorMap = {
    white: 'standard',
    'faded-gray': 'subtle',
    'light-red': 'backdrop',
    'light-berry': 'backdrop',
    berry: 'backdrop',
    'dark-berry': 'backdrop',
    'light-aqua': 'backdrop',
    aqua: 'backdrop',
    'dark-aqua': 'backdrop',
    'light-smoke': 'backdrop',
    smoke: 'backdrop',
    'dark-smoke': 'backdrop',
    'light-green': 'backdrop',
    green: 'backdrop',
    'dark-green': 'backdrop',
    'faded-moss': 'subtle',
    'light-moss': 'backdrop',
    moss: 'backdrop',
    'dark-moss': 'backdrop',
    'light-gray': 'subtle',
    gray: 'subtle',
    'dark-gray': 'subtle',
    subtle: 'subtle',
    standard: 'standard',
    backdrop: 'backdrop'
};
function mapLegacyTheme(theme) {
    if (!theme) {
        return 'standard';
    }
    return themeColorMap[theme] ?? theme;
}
const accentColorMap = {
    black: 'info-strong',
    white: 'info-subtle',
    'faded-gray': 'info-subtle',
    'light-berry': 'info-subtle',
    'dark-berry': 'info-strong',
    'light-aqua': 'info-subtle',
    'dark-aqua': 'info-strong',
    'light-smoke': 'info-subtle',
    'dark-smoke': 'info-strong',
    'light-green': 'info-subtle',
    'dark-green': 'info-strong',
    'light-moss': 'info-subtle',
    'dark-moss': 'info-strong',
    'light-gray': 'info-subtle',
    'dark-gray': 'info-strong',
    'info-subtle': 'info-subtle',
    'info-strong': 'info-strong'
};
function mapLegacyAccent(accent) {
    if (!accent) {
        return 'info-subtle';
    }
    return accentColorMap[accent] ?? 'info-strong';
}
export const InfoTeaser = ({ accent, anchorId, button, headline, text, theme })=>{
    return /*#__PURE__*/ _jsx("section", {
        className: classNames(utilityStyles['content-container'], styles.section, themes[mapLegacyTheme(theme)]),
        "data-testid": "info-teaser",
        id: anchorId,
        children: /*#__PURE__*/ _jsxs("div", {
            className: classNames(styles.container, themes[mapLegacyAccent(accent)]),
            children: [
                /*#__PURE__*/ _jsx(InfoM, {
                    className: styles.icon
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.content,
                    children: [
                        headline && /*#__PURE__*/ _jsx(Headline, {
                            renderAs: "h2",
                            size: "s",
                            className: styles.headline,
                            children: headline
                        }),
                        text && /*#__PURE__*/ _jsx(Text, {
                            children: text
                        }),
                        button?.length === 1 && /*#__PURE__*/ _jsx(AButton, {
                            ...button[0],
                            className: styles.button,
                            variant: "neutral-outline"
                        })
                    ]
                })
            ]
        })
    });
};

//# sourceMappingURL=info-teaser.js.map